import { Tooltip } from 'antd'
import { SkeletonLine } from 'components/Skeleton'
import { Text } from 'components/Text'
import { numbersWithCommas } from 'helpers/regex'
import { MdClear } from 'react-icons/md'
import { Wrapper } from 'styles/styleSystem/wrapper'
import { SearchResultsClearWrapper } from './styles'
import _isEmpty from 'lodash-es/isEmpty'
import { useWindowSize } from 'contexts/WindowSizeContext'
import { memo } from 'react'

interface SearchResultsProps {
  count: number
  totalCount: number
  term: string
  clearTerm: () => void | null
  loading: boolean
}

export const SearchResults: React.FC<SearchResultsProps> = memo(
  ({ count, totalCount, term, clearTerm = null, loading = false }) => {
    const { isMobile } = useWindowSize()

    if (loading) {
      return (
        <Wrapper height="20px">
          <SkeletonLine width="100px" height="20px" margin="0" />
        </Wrapper>
      )
    }

    const renderResultCount = () => {
      if (totalCount <= 0 || count === 0) {
        if (!_isEmpty(term)) {
          return `No results for `
        }
        return 'No results'
      }
      if (count <= totalCount) {
        const text = `${numbersWithCommas(count)} of ${numbersWithCommas(
          totalCount
        )} results`
        if (!_isEmpty(term)) {
          return `${text} for `
        }
        return text
      }
      return `${numbersWithCommas(count)} results for `
    }

    return (
      <Wrapper
        display="flex"
        alignItems="center"
        spacing={4}
        horizontal
        width={!clearTerm ? 'unset' : !isMobile ? '40%' : '100%'}
      >
        <Wrapper display="inline-block" alignItems="center">
          <Text
            size={isMobile ? 'lg' : 'md'}
            weight="light"
            color="secondary"
            leading="unset"
            noWrap
          >
            {renderResultCount()}
          </Text>
        </Wrapper>
        {!_isEmpty(term) && (
          <Wrapper display="flex" alignItems="center" width="60%">
            <Tooltip title={decodeURIComponent(term)}>
              <Text
                noWrap={!isMobile}
                lines={isMobile ? 2 : null}
                leading="unset"
                size={isMobile ? 'lg' : 'md'}
                ellipsis={!isMobile}
                width="100%"
              >
                {decodeURIComponent(term)}
              </Text>
            </Tooltip>
            {!!clearTerm && (
              <Tooltip title="Clear search term">
                <SearchResultsClearWrapper onClick={clearTerm}>
                  <MdClear size={isMobile ? 18 : 14} />
                </SearchResultsClearWrapper>
              </Tooltip>
            )}
          </Wrapper>
        )}
      </Wrapper>
    )
  }
)
